import { render, staticRenderFns } from "./MailAssessment.vue?vue&type=template&id=ff781edc&scoped=true&"
import script from "./MailAssessment.vue?vue&type=script&lang=js&"
export * from "./MailAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff781edc",
  null
  
)

export default component.exports